module.exports = __webpack_public_path__ + "img/trip-advisor.50e0bdaa.jpg";